import { React, useState, useEffect } from "react";

const PopUpBacaratResults = ({ resultsData, catMid, marketType }) => {
    /* PopUpBetfairResults */

    const resultData = resultsData;
    console.log(resultData);

    if (!resultsData) return null;

    const dataObj = resultsData;

    const win1 = dataObj.rnr1_status;
    const win2 = dataObj.rnr2_status;
    const win3 = dataObj.rnr3_status;
    const win4 = dataObj.rnr4_status;
    const win5 = dataObj.rnr5_status;
    const win6 = dataObj.rnr6_status;
    const win7 = dataObj.rnr7_status;
    const win8 = dataObj.rnr8_status;

    const bgCls1 = win1 === "WINNER" ? "bgwinner" : "bgLoser";
    const bgCls2 = win2 === "WINNER" ? "bgwinner" : "bgLoser";
    const bgCls3 = win3 === "WINNER" ? "bgwinner" : "bgLoser";
    const bgCls4 = win4 === "WINNER" ? "bgwinner" : "bgLoser";

    const tdCls1 = win1 === "WINNER" ? "TdResultsWin" : "";
    const tdCls2 = win2 === "WINNER" ? "TdResultsWin" : "";
    const tdCls3 = win3 === "WINNER" ? "TdResultsWin" : "";
    const tdCls4 = win4 === "WINNER" ? "TdResultsWin" : "";

    const cardsArr = dataObj.cards_desc?.split(",");
    const rnr1Arr = dataObj.rnr1_desc?.split(",");
    const rnr2Arr = dataObj.rnr2_desc?.split(",");
    const rnr3Arr = dataObj.rnr3_desc?.split(",");
    const rnr4Arr = dataObj.rnr4_desc?.split(",");
    const getCardImageResult = (cardValue) => {
        if (cardValue === "NOT AVAILABLE") {
            return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
        }

        if (["28", "33", "39", "40"].includes(cardValue)) {
            return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
        }

        return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
    };
    const tableStyle = { width: "100%", borderCollapse: "collapse" };
    const rowFlexStyle = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
        background: "transparent"
    };
    const tdResultsStyle = {
        padding: 8,
        minWidth: 180,
        boxSizing: "border-box"
    };
    const playerCardsStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowWrap: "break-word"
    };
    const playerNameStyle = {
        fontWeight: "bold",
        textAlign: "center",
        width: "100%"
    };
    const cardImagesStyle = {
        display: "flex",
        alignItems: "left",
        gap: 3,
        flexWrap: "wrap",
        width: "100%"
    };
    const cardComStyle = {
        display: "flex",
        justifyContent: "center",
        gap: 3,
        flexWrap: "wrap",
        width: "100%"
    };
    const cardImgStyle = {
        width: 40,
        height: 60,
        objectFit: "cover",
        borderRadius: 5
    };
    const playerStatusStyle = {
        color: "#000",
        marginTop: 5,
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        width: "100%"
    };
    const formatDateTime = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const seconds = String(d.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    return (
        <>

            <div id="ResultsData">
                <div className="left-content site_family">

                    <div class="card">
                        <div class="card-header">
                            <b>{formatDateTime(dataObj.round_od)} - (<b>Round Id = </b> {catMid})</b>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6" style={{ margin: "auto", textAlign: "center" }}>
                                    <div class="player-item">
                                        <b><span class="name" style={{ color: "#000" }}> {dataObj.cat_rnr1}</span></b>
                                        <div class="player-card">
                                            <div className="card-images" style={cardImagesStyle}>
                                                {rnr1Arr?.map((card, index) => {
                                                    const cardImage = getCardImageResult(card);
                                                    return (
                                                        <img
                                                            key={index}
                                                            src={cardImage}
                                                            loading="lazy"
                                                            style={cardImgStyle}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6" style={{ margin: "auto", textAlign: "center" }}>
                                    <div class="player-item">
                                        <b><span class="name" style={{ color: "#000" }}> {dataObj.cat_rnr2}</span></b>
                                        <div class="player-card">
                                            <div className="card-images" style={cardImagesStyle} >
                                                {rnr2Arr?.map((card, index) => {
                                                    const cardImage = getCardImageResult(card);
                                                    return (
                                                        <img
                                                            key={index}
                                                            src={cardImage}
                                                            loading="lazy"
                                                            style={cardImgStyle}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6" style={{ margin: "auto", textAlign: "center" }}>
                                    <div class="player-item">
                                        <b><span class="name" style={{ color: "#000" }}> {dataObj.cat_rnr3}</span></b>
                                        <div class="player-card">
                                            <div className="card-images" style={cardImagesStyle}>
                                                {rnr3Arr?.map((card, index) => {
                                                    const cardImage = getCardImageResult(card);
                                                    return (
                                                        <img
                                                            key={index}
                                                            src={cardImage}
                                                            loading="lazy"
                                                            style={cardImgStyle}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ margin: "auto", textAlign: "center" }}>
                                <div class="market-runners">
                                    <div>
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr1}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>

                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr1_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="market-runners">
                                    <div>
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr2}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>
                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr2_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="market-runners">
                                    <div>
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr3}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>
                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr3_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="market-runners">
                                    <div >
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr4}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>
                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr4_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="market-runners">
                                    <div >
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr5}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>
                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr5_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="market-runners">
                                    <div >
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr6}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>
                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr6_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="market-runners">
                                    <div >
                                        <h3 class="runner-name">
                                            <div class="runner-info">
                                                <span class="clippable runner-display-name">
                                                    <h4 class="clippable-spacer" data-toggle="tooltip" data-placement="top" data-html="true">
                                                        {dataObj.cat_rnr7}
                                                    </h4>
                                                </span>
                                            </div>
                                        </h3>
                                        <div style={{ display: "block" }}>
                                            <div>
                                                {dataObj.rnr7_status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <style>
                    {`
                    .TdResults {
                        padding: 0;
                        vertical-align: top;
                        flex: 1 1 auto;
                        box-sizing: border-box;
                        max-width: calc(33.33% - 20px);
                        min-width: 120px;
                        background: linear-gradient(#535353, #0f0f0f);
                        border-radius: 10px;
                        margin: 1px;
                    }
                    .bgwinner {
                        border-radius: 10px;
                        background-color: #cf8d2e !important;
                    }
                    .bgLoser {
                        border-radius: 10px;
                        background-color: #cf3f3f !important;
                    }
                    .TdResultsWin {
                        background: #008000 !important;
                    }
                    .player-card {
                        border: 1px solid rgba(14, 99, 8, 0.25) !important;
                        border-radius: 12px;
                        padding: 3px 5px 0px;
                        backdrop-filter: blur(1px);
                        background: transparent;
                        margin-top:-5px;
                    }
                    .runner-name {
                        text-align: center !important;
                        font-size: 30px !important;
                    }

                    .runner-info {
                        display: flex;
                        justify-content: center;
                        width: 100%;
                    }

                    .runner-display-name {
                        text-align: center;
                    }
                    .clippable-spacer {
                        font-size: 20px !important;
                        text-align: center !important;
                    }
                    `}
                </style>
            </div>
        </>
    );
};

export default PopUpBacaratResults;